import { RotateCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@playbooks/ui/components/button'

const Footer = ({ setShowConfirmDialog }: { setShowConfirmDialog: (value: boolean) => void }) => {
  const { t } = useTranslation()

  const handleResetClick = () => {
    setShowConfirmDialog(true)
  }

  return (
    <>
      <div className="shrink-0 flex justify-between items-center py-4">
        <Button
          type="button"
          variant="secondary"
          data-testid="reset-button"
          // 436px is min width of the iframe when button should make ellipsis own texts to not overlap
          className="border-secondary max-[436px]:max-w-24"
          onClick={handleResetClick}
        >
          <RotateCw size={16} />
          <div className="max-sm:truncate max-w-full">{t('footer.reset', 'Reset')}</div>
        </Button>
        <a href="https://linkando.com/webplays" className="hidden" target="_blank">
          {t('footer.powered_by', 'About WebPlays')}
        </a>
        {/* A container for the weglot language switcher */}
        <div id="lang-switcher" />
      </div>
    </>
  )
}

export default Footer
